import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { forEach } from 'lodash-es';
import { ConfirmationService } from 'primeng/api';
import { NotificationService, TranslationService } from 'src/app/shared';
import { EcomItemImageDto } from '../shared/dto/ecom-item-image.dto';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomService } from '../shared/ecom.service';

@Component({
  selector: 'wl-ecom-item-edit-images',
  templateUrl: './ecom-item-edit-images.component.html',
  styleUrls: ['./ecom-item-edit-images.component.less'],
    standalone: false
})
export class EComItemEditImagesComponent implements OnInit, OnChanges {
  @Input() eCommerceItem: EcomItemDto;
  @Output() eComItemImagesChanged = new EventEmitter<{
    eCommerceItem: EcomItemDto;
    eComItemImages: Array<EcomItemImageDto>;
    selectedPrimaryImage: string;
  }>();

  eComItemImages: Array<EcomItemImageDto> = [];
  awaitingResponse = false;
  isLoading = false;
  selectedPrimaryImage: string;

  constructor(private _ecomService: EcomService, private _notificationService: NotificationService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem) {
      if (this.eCommerceItem) {
        this.isLoading = true;
        this.getEcomItemImages();
        this.isLoading = false;
      }
    }
  }

  ngOnInit(): void {}

  getEcomItemImages() {
    if (this.eCommerceItem?.ItemId > 0) {
      this._ecomService.GetEcomItemImages(this.eCommerceItem.ItemId, true).then((data) => {
        this.eComItemImages = data;
      });
    } else {
      this.eComItemImages = [];
    }
  }

  isPrimaryChanged(index: number) {
    this.eComItemImages[index].IsPrimary = true;
    this.eCommerceItem.ImageUrl = this.eComItemImages[index].S3Url;
    if (this.eComItemImages[index].S3File) {
      this.selectedPrimaryImage = this.eComItemImages[index].S3File.name;
    } else {
      this.selectedPrimaryImage = this.eComItemImages[index].S3Url.substring(this.eComItemImages[index].S3Url.lastIndexOf('/') + 1);
    }
    this.updateEcomItemImage();
  }

  deleteImage(index: number) {
    if (this.eComItemImages.length > 0) {
      let url = this.eComItemImages[index]?.S3Url as string;
      if (url?.indexOf('data:') < 0) {
        let fileName = url?.substring(url.lastIndexOf('/') + 1);
        let PrimaryImageName = this.eCommerceItem.ImageUrl?.substring(this.eCommerceItem.ImageUrl.lastIndexOf('/') + 1);
        this._ecomService
          .DeleteEcomItemImage(this.eCommerceItem.ItemId, fileName)
          .then(() => {
            this.isLoading = true;
            if (fileName === PrimaryImageName) {
              this.eCommerceItem.ImageUrl = '';
            }
            this.getEcomItemImages();
            this.eComItemImages.splice(index, 1);
            this._ecomService.UpdateEcomItem(this.eCommerceItem);
            this._notificationService.translateSuccess('ecommerce.item.images.delete-success');
            this.updateEcomItemImage();
          })
          .catch((err) => {
            this._notificationService.httpError(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        if (this.eComItemImages[index].S3Url == this.eCommerceItem.ImageUrl) {
          this.eCommerceItem.ImageUrl = '';
        }
        this.eComItemImages.splice(index, 1);
        this.updateEcomItemImage();
      }
    }
  }

  deletePrimaryImage(s3Url: string) {
    let imageToDelete = null;
    let indexToDelete = -1;
    if (this.eCommerceItem?.ItemId > 0) {
      indexToDelete = this.eComItemImages.map((x) => x.S3Url).indexOf(s3Url);
      imageToDelete = s3Url?.indexOf('data:') < 0 ? s3Url.substring(s3Url.lastIndexOf('/') + 1) : '';
      if (imageToDelete) {
        this._ecomService
          .DeleteEcomItemImage(this.eCommerceItem?.ItemId, imageToDelete)
          .then(() => {
            this.isLoading = true;
            this.getEcomItemImages();
            this.eCommerceItem.ImageUrl = '';
            this._ecomService.UpdateEcomItem(this.eCommerceItem);
            this._notificationService.translateSuccess('ecommerce.item.images.delete-success');
          })
          .catch((err) => {
            this._notificationService.httpError(err);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
      this.eComItemImages?.splice(indexToDelete, 1);
      this.eCommerceItem.ImageUrl = '';
      this.updateEcomItemImage();
    }
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      this.awaitingResponse = true;
      var filesAmount = event.target.files.length;
      var imageNames: Array<string> = [];
      for (let i = 0; i < this.eComItemImages.length; i++) {
        let s3Url = this.eComItemImages[i].S3Url as string;
        let fileName = s3Url?.substring(s3Url.lastIndexOf('/') + 1);
        imageNames.push(fileName);
      }
      for (let i = 0; i < filesAmount; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]);
        reader.onload = () => {
          if (event.target.files[i].size < 5000000) {
            if (imageNames.filter((x) => x == event.target.files[i].name).length == 0) {
              this.eComItemImages.push({
                S3Url: reader.result.toString(),
                IsPrimary: false,
                S3File: event.target.files[i],
              });
            }
          }
        };
      }
      this.awaitingResponse = false;
      this.updateEcomItemImage();
    }
  }

  updateEcomItemImage() {
    this.eComItemImagesChanged.emit({
      eCommerceItem: this.eCommerceItem,
      eComItemImages: this.eComItemImages,
      selectedPrimaryImage: this.selectedPrimaryImage,
    });
  }
}
